<ng-container *ngIf="isBrowser">
  <div
    class="modal-header rs-enhanced-header mb-2"
    [class.rs-header--video-review]="show_video"
  >
    <div class="rs-header-content" *ngIf="!show_video">
      <span
        class="rs-kicker"
        *ngIf="!showemailSection && !sendInternalmail"
        >STORY ENGINE</span
      >
      <h5 class="modal-title">
        {{
          !showemailSection && !sendInternalmail
            ? "Request a Story"
            : "Send Mail"
        }}
      </h5>
      <p
        class="rs-header-description"
        *ngIf="!showemailSection && !sendInternalmail"
      >
        Invite someone to share a story, or craft a prompt your community can
        answer.
      </p>
    </div>
    <button type="button" (click)="cancel()" class="close">
      <span aria-hidden="true">
        <svg role="img">
          <use xlink:href="#icon-close"></use></svg
      ></span>
    </button>
  </div>

  <div class="tag_conatainer">
    <div
      class="modal-body request-story"
      [ngClass]="{ expand: isShowModal }"
      [formGroup]="requestForm"
    >
      <div class="headings_of_invite_content">
        <div *ngIf="!show_video" class="user-type-tabs-container">
          <div class="user-type-pill-toggle">
            <button
              type="button"
              class="user-type-pill-option"
              [class.active]="requestForm.value.userStatus === 'user'"
              [disabled]="initialState.allowUser === false"
              [title]="initialState.allowUser === false ? 'This prompt is for guests only' : ''"
              (click)="setUserStatus('user')"
            >
              From a User
            </button>
            <button
              type="button"
              class="user-type-pill-option"
              [class.active]="requestForm.value.userStatus === 'Guestuser'"
              [disabled]="initialState.allowGuest === false"
              [title]="initialState.allowGuest === false ? 'This prompt is internal, for users only' : ''"
              (click)="setUserStatus('Guestuser')"
            >
              From a Guest
            </button>
          </div>
        </div>
      </div>

      <ng-container *ngIf="requestForm.value.userStatus == 'user'">
        <div
          (keyup.enter)="handleComKeyEnter()"
          class="story-flow-view__box view-box-people outline-none"
          [ngClass]="{ current: !viewmodel.isStoryCreating }"
        >
          <form
            [hidden]="isCopyCode"
            [formGroup]="form"
            class="view-box-people__search setting_form"
            (keyup.enter)="exceptHandleComKeyEnter($event)"
          >
            <div class="view-box-media__tab-item">
              <div class="search-input">
                <input
                  id="searchUnsplash"
                  formControlName="keyword"
                  type="text"
                  placeholder="Search"
                  class="form-control"
                  autofocus
                />
              </div>
              <div
                class="view-box-people__search-button button-label"
                [ngClass]="{ searching: viewmodel.searching }"
              >
                <div [hidden]="!viewmodel.searching" class="lds-ellipsis">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <button [hidden]="viewmodel.searching" type="submit">
                  <i class=""></i>
                </button>
              </div>
            </div>
          </form>
          <div class="view-box-people__result spacer">
            <div class="no___members" *ngIf="members && members?.length == 0">
              NO USER FOUND.Invite them to submit as a guest.
            </div>
            <scrollbar
              #scrollbar
              *ngIf="members && members?.length > 0"
              (onYReachEnd)="onYReachEnd()"
              (onPositionChanged)="onPositionChanged()"
            >
              <div class="l-people-result">
                <label
                  class="l-people-result__item"
                  *ngFor="
                    let player of members;
                    index as i;
                    trackBy: memberTrackByFnc
                  "
                  title="{{ player.title ? player.title : '' }}"
                >
                  <span class="l_people_request">
                    <gs-avatar
                      [src]="player.avatar"
                      isBackground="true"
                      classCss="avatar"
                    ></gs-avatar>
                  </span>

                  <ng-container *ngIf="player.storyInviteEnabled !== false">
                    <span class="l-people-result__content">
                      <span class="l-people-result__name"
                        >{{ player.displayName }}&nbsp; -</span
                      >
                      <span class="l-people-result__mail"
                        >&nbsp;{{ player.email }}</span
                      >
                    </span>
                    <span class="l-people-result__checkbox" *ngIf="!isCopyCode">
                      <input
                        type="checkbox"
                        [(ngModel)]="player.checked"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="selectItem(player)"
                      />
                      <span> </span>
                    </span>
                    <span class="l-people-result__checkbox" *ngIf="isCopyCode">
                      <span
                        data-toggle="tooltip"
                        #copyToolTip
                        class="copy-text-{{ i }}"
                        data-placement="right"
                        [title]="
                          !hideSendanCopylinkButton
                            ? 'Create new link first'
                            : 'Click to copy'
                        "
                        [style.opacity]="
                          !hideSendanCopylinkButton ? '0.5' : '1'
                        "
                        [style.cursor]="
                          !hideSendanCopylinkButton ? 'not-allowed' : 'pointer'
                        "
                        ><span></span>
                        <span
                          (click)="
                            !hideSendanCopylinkButton
                              ? $event.stopPropagation()
                              : copyMessage(player, copyToolTip)
                          "
                          ><i class="fas fa-link"></i
                        ></span>
                        <span> </span>
                      </span>
                    </span>
                  </ng-container>

                  <ng-container
                    *ngIf="
                      player.storyInviteEnabled === false && !player.checked
                    "
                  >
                    <span class="l-people-result__content">
                      <span class="l-people-result__name text-dark">
                        <span
                          data-toggle="tooltip"
                          data-placement="right"
                          title="Unavailable to add"
                          class="pr-2"
                          ><span>{{ player.displayName }}</span>
                          <svg role="img" class="icon16">
                            <use xlink:href="#icon-info"></use>
                          </svg>
                        </span>
                      </span>
                      <span class="l-people-result__mail"
                        >-&nbsp; {{ player.email }}&nbsp;</span
                      >
                    </span>
                  </ng-container>
                  <span class="copied-success mt-1" *ngIf="player?.linkCopied"
                    >Link copied!</span
                  >
                </label>
                <div
                  class="l-story-box-media__loading"
                  [hidden]="!loadMore || viewmodel.searching"
                  *ngIf="!isCopyCode"
                >
                  Loading more ....
                </div>
              </div>
            </scrollbar>
            <div
              class="container mt-5 text-center"
              *ngIf="
                viewmodel.isPlayerCreating ||
                (viewmodel.isPlayerLoading && !(members && members?.length > 0))
              "
            >
              <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3" *ngIf="!sendInternalmail">
          <!--<h6 class="font-weight-bold mb-3 mr-3 mt-3">Help Them Get Started</h6>-->
          <div class="action-cards-row">
            <button
              *ngIf="showRequestedUser"
              type="button"
              class="action-card"
              [class.has-video]="is_video"
              (click)="!is_video ? startRecording() : watchVideo()"
            >
              <span class="action-card-icon">
                <i class="fa-solid fa-video" aria-hidden="true"></i>
              </span>
              <span class="action-card-label">{{
                !is_video ? "Add Greeting" : "Watch Video"
              }}</span>
            </button>
            <button
              *ngIf="CheckActive"
              type="button"
              class="action-card"
              [disabled]="
                stepActive && stepActive.length && stepActive.length == 1
              "
              (click)="addTag()"
            >
              <span class="action-card-icon">
                <i class="fa-solid fa-tags" aria-hidden="true"></i>
              </span>
              <span class="action-card-label">Add Tags</span>
            </button>
            <button
              *ngIf="CheckActive"
              type="button"
              class="action-card"
              (click)="addMedia()"
            >
              <span class="action-card-icon">
                <i class="fa-solid fa-image" aria-hidden="true"></i>
              </span>
              <span class="action-card-label">Add Media</span>
            </button>
          </div>
          <div
            class="rs-greeting-upload-progress"
            *ngIf="uploaderViewModel.isUploading || showelipse"
          >
            <p class="rs-greeting-upload-progress__label">
              {{
                uploaderViewModel.isUploading
                  ? "Uploading video… " + uploaderViewModel.progress + "%"
                  : uploaderViewModel.progress >= 100
                    ? "Video uploaded"
                    : "Processing video…"
              }}
            </p>
            <div class="rs-greeting-upload-progress__track">
              <div
                class="rs-greeting-upload-progress__fill"
                [style.width]="
                  uploaderViewModel.isUploading
                    ? uploaderViewModel.progressCss
                    : '100%'
                "
              ></div>
            </div>
          </div>
        </div>
        <div class="email-popup-box" *ngIf="sendInternalmail">
          <div class="email-popup-header">
            <!--  <h6 class="mb-0 font-weight-bold">Edit Email Subject & Message</h6> -->
          </div>

          <div class="form-group mt-3" *ngIf="!is_not_other_email">
            <gs-input-material
              label="Sender Name"
              name="Sender Name"
              formControlName="emailSendername"
              placeholder="E.g., We'd love to hear your story!"
              [formControl]="requestForm.controls.emailSendername"
              type="text"
            ></gs-input-material>
          </div>
          <!-- Subject Input -->
          <div class="form-group mt-3">
            <gs-input-material
              label="Email Subject"
              name="emailSubject"
              formControlName="emailSubject"
              placeholder="E.g., We'd love to hear your story!"
              [formControl]="requestForm.controls.emailSubject"
              type="text"
            ></gs-input-material>
          </div>

          <!-- Email Body WYSIWYG -->
          <div class="form-group">
            <gs-area-wysiwyg
              label="Email Message"
              name="emailTemplate"
              placeholder="Type your message here..."
              rows="6"
              formControlName="emailTemplate"
              [formControl]="requestForm.controls.emailTemplate"
              type="text"
            ></gs-area-wysiwyg>
          </div>
        </div>
        <div class="remark-box" [@showhide]="isDispalyMenu ? 'show' : 'hide'">
          <div class="close__popup_Design">
            <button
              class="btn btn-trans ml-3"
              (click)="isDispalyMenu = false; show_video = false"
            >
              <svg role="img" class="">
                <use xlink:href="#icon-expand"></use>
              </svg>
            </button>
          </div>
          <!--<h6 style="text-align: center;">Included Prompts</h6>-->
          <div class="video_container" *ngIf="show_video && isDispalyMenu">
            <video
              class="video_player"
              #videoPlayer
              controls
              width="100%"
            ></video>

            <div class="below_content">
              <div
                class="add_message"
                (click)="removeVideo()"
                [style.color]="is_video ? '#1db6bb' : ''"
              >
                <h6>
                  Remove Video
                  <span><i class="ml-1 fa-solid fa-video"></i></span>
                </h6>
              </div>
            </div>
          </div>

          <!-- Back button to return to main modal -->
          <div class="text-center mt-4 mb-2" *ngIf="!show_video">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="isDispalyMenu = false"
            >
              <i class="fas fa-arrow-left"></i>&nbsp; Back to Request
            </button>
          </div>
        </div>
        <ng-container
          *ngIf="
            showRequestedUser &&
            requestedMembers.length > 1 &&
            !sendInternalmail
          "
        >
          <div class="job__select mb-2">
            <ng-select
              class="job-select"
              [placeholder]="''"
              [items]="requestedMembers"
              [multiple]="false"
              [closeOnSelect]="true"
              [selectableGroup]="true"
              maxSelectedItems="1"
              bindValue="id"
              bindLabel="title"
              formControlName="userselcted"
            >
              <ng-template
                ng-option-tmp
                let-item="item"
                let-item$="item$"
                let-index="index"
              >
                <div class="mobile-check custom-control custom-checkbox">
                  <input
                    id="item-{{ index }}"
                    class="custom-control-input"
                    type="checkbox"
                    [ngModelOptions]="{ standalone: true }"
                    [ngModel]="item$.selected"
                  />
                  <label class="custom-control-label">{{ item.title }}</label>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </ng-container>
        <div class="row froala-wysiwyg" *ngIf="!sendInternalmail">
          <div class="col-12 request_edit">
            <!-- <gs-area-material
              label=""
              name="Message" placeholder="What happened? Why does it matter?" rows="2"
              cssClass="spacing-lg" formControlName="internalmessage" [formControl]="requestForm.controls.internalmessage">
          </gs-area-material> -->
            <gs-area-wysiwyg
              label="Content"
              name="Message"
              placeholder="Add a popup greeting, instructions, or a story tip..."
              rows="7"
              cssClass="spacing-lg"
              is
              name="Content"
              formControlName="internalmessage"
              [formControl]="requestForm.controls.internalmessage"
              type="text"
              [autoFocus]="true"
            ></gs-area-wysiwyg>
          </div>
        </div>

        <div class="generate__box">
          <div class="mr-3" *ngIf="sendInternalmail">
            <button
              type="button"
              [style.background]="primary_color ? primary_color : ''"
              (click)="backInternalStories()"
              class="btn btn-pink min-width rs-footer-btn rs-footer-btn--secondary"
            >
              Back
            </button>
          </div>
          <ng-container *ngIf="!sendInternalmail">
            <div
              class="ml-3"
              (click)="
                !hideSendanCopylinkButton
                  ? GenearateInternalMainlLink()
                  : openMailBox()
              "
            >
              <button
                [style.background]="primary_color ? primary_color : ''"
                type="button"
                [disabled]="
                  !selectedData.length ||
                  isLoading ||
                  diableonsearching ||
                  isGreetingVideoPending ||
                  disableSubmit
                "
                class="btn btn-pink min-width rs-footer-btn rs-footer-btn--primary"
              >
                <div class="dot-pulse" *ngIf="showelipse"></div>
                {{ !hideSendanCopylinkButton ? "Create Link" : "Send Email" }}
              </button>
            </div>
          </ng-container>
          <ng-container>
            <div class="mr-3" *ngIf="sendInternalmail">
              <button
                [style.background]="primary_color ? primary_color : ''"
                type="button"
                (click)="sendIntenalMainEmail()"
                class="btn btn-pink min-width rs-footer-btn rs-footer-btn--primary"
              >
                Send
              </button>
            </div>
          </ng-container>

          <ng-container>
            <div class="lang-icon-select" *ngIf="!sendInternalmail">
              <button
                type="button"
                class="rs-footer-btn rs-footer-btn--secondary"
                (click)="toggleLangDropdown($event)"
              >
                <i class="far fa-language"></i>
                <span>Translate</span>
              </button>

              <!-- CUSTOM DROPDOWN -->
              <ul class="icon-dropdown" *ngIf="langDropdownOpen">
                <li
                  *ngFor="let lang of selectedLanguages"
                  (click)="selectLanguage(lang, $event)"
                  [class.active]="
                    lang.code === requestForm.get('languageSelected')?.value
                  "
                >
                  <img [src]="lang.flag" width="20" height="14" />
                  {{ lang.name }}
                </li>
              </ul>
            </div>
          </ng-container>

          <!-- <ng-container>
            <div *ngIf="hideSendanCopylinkButton">
              <button [style.background]="primary_color ? primary_color : ''" type="button" (click)="sendIntenalMainEmail()" class="btn btn-pink min-width">
                Send Email
            </button>
            </div>
        
          </ng-container> -->
        </div>
      </ng-container>

      <ng-container *ngIf="requestForm.value.userStatus == 'Guestuser'">
        <!--<h6 class="">Author Details</h6>-->
        <div class="pt-3" *ngIf="!showemailSection">
          <div class="row">
            <div class="col-12">
              <gs-input-material
                #guestNameInput
                label="{{
                  !requestForm.controls.note_email.disabled
                    ? 'Guest Name or Note*'
                    : ''
                }}"
                name="{{
                  !requestForm.controls.email.disabled ? 'Description*' : ''
                }}"
                placeholder="!requestForm.controls.note_email.disabled ? 'Description*' : ''"
                formControlName="note_email"
                [formControl]="requestForm.controls.note_email"
                type="text"
                [hideErrorMessage]="true"
              ></gs-input-material>
            </div>
          </div>
        </div>

        <div class="mb-3" *ngIf="!showemailSection">
          <!--<h6 class="font-weight-bold mb-3 mr-3 mt-3">Help Them Get Started</h6>-->
          <div class="action-cards-row">
            <button
              *ngIf="showRequestedUser"
              type="button"
              class="action-card"
              [class.has-video]="is_video"
              (click)="!is_video ? startRecording() : watchVideo()"
            >
              <span class="action-card-icon">
                <i class="fa-solid fa-video" aria-hidden="true"></i>
              </span>
              <span class="action-card-label">{{
                !is_video ? "Add Greeting" : "Watch Video"
              }}</span>
            </button>
            <button
              *ngIf="CheckActive"
              type="button"
              class="action-card"
              [disabled]="
                stepActive && stepActive.length && stepActive.length == 1
              "
              (click)="addTag()"
            >
              <span class="action-card-icon">
                <i class="fa-solid fa-tags" aria-hidden="true"></i>
              </span>
              <span class="action-card-label">Add Tags</span>
            </button>
            <button
              *ngIf="CheckActive"
              type="button"
              class="action-card"
              (click)="addMedia()"
            >
              <span class="action-card-icon">
                <i class="fa-solid fa-image" aria-hidden="true"></i>
              </span>
              <span class="action-card-label">Add Media</span>
            </button>
          </div>
          <div
            class="rs-greeting-upload-progress"
            *ngIf="uploaderViewModel.isUploading || showelipse"
          >
            <p class="rs-greeting-upload-progress__label">
              {{
                uploaderViewModel.isUploading
                  ? "Uploading video… " + uploaderViewModel.progress + "%"
                  : uploaderViewModel.progress >= 100
                    ? "Video uploaded"
                    : "Processing video…"
              }}
            </p>
            <div class="rs-greeting-upload-progress__track">
              <div
                class="rs-greeting-upload-progress__fill"
                [style.width]="
                  uploaderViewModel.isUploading
                    ? uploaderViewModel.progressCss
                    : '100%'
                "
              ></div>
            </div>
          </div>
        </div>

        <div
          class="email-popup-box"
          *ngIf="isSingleInternalRequested && showemailSection"
        >
          <div class="guest_email" formArrayName="users" class="mb-4">
            <div
              *ngFor="let user of users.controls; let i = index"
              [formGroupName]="i"
              class="row mb-2 align-items-center"
            >
              <!-- First Name -->
              <div class="col-md-5">
                <gs-input-material
                  label="First Name*"
                  name="firstName-{{ i }}"
                  placeholder="Enter First Name"
                  formControlName="firstName"
                  [formControl]="user.get('firstName')"
                  type="text"
                >
                </gs-input-material>
              </div>

              <!-- Email -->
              <div class="col-md-5">
                <gs-input-material
                  label="Email*"
                  name="email-{{ i }}"
                  placeholder="Enter Email"
                  formControlName="author_email"
                  [formControl]="user.get('author_email')"
                  type="text"
                >
                </gs-input-material>
              </div>

              <!-- Actions -->
              <div class="col-md-2 d-flex gap-2 align-items-center">
                <!-- Add (only if last is valid) -->
                <ng-container>
                  <button
                    type="button"
                    class="btn btn-success btn-icon add_btn"
                    [disabled]="!lastUserValid"
                    (click)="addUser()"
                    title="Add another"
                  >
                    <i class="fa fa-plus"></i>
                  </button>
                </ng-container>

                <!-- Remove (if more than one user) -->
                <ng-container *ngIf="users.length > 1">
                  <button
                    type="button"
                    class="btn btn-danger btn-icon remove_btn"
                    (click)="removeUser(i)"
                    title="Remove user"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="email-popup-header">
            <!--  <h6 class="mb-0 font-weight-bold">Edit Email Subject & Message</h6> -->
          </div>

          <div class="form-group mt-3" *ngIf="!is_not_other_email">
            <gs-input-material
              label="Sender Name"
              name="Sender Name"
              formControlName="emailSendername"
              placeholder="E.g., We'd love to hear your story!"
              [formControl]="requestForm.controls.emailSendername"
              type="text"
            ></gs-input-material>
          </div>
          <!-- Subject Input -->
          <div class="form-group mt-3">
            <gs-input-material
              label="Email Subject"
              name="emailSubject"
              formControlName="emailSubject"
              placeholder="E.g., We'd love to hear your story!"
              [formControl]="requestForm.controls.emailSubject"
              type="text"
            ></gs-input-material>
          </div>

          <!-- Email Body WYSIWYG -->
          <div class="form-group">
            <gs-area-wysiwyg
              label="Email Message"
              name="emailTemplate"
              placeholder="Type your message here..."
              rows="6"
              formControlName="emailTemplate"
              [formControl]="requestForm.controls.emailTemplate"
              type="text"
            ></gs-area-wysiwyg>
          </div>
        </div>
        <div
          class="remark-box"
          *ngIf="!showemailSection"
          [@showhide]="isDispalyMenu ? 'show' : 'hide'"
        >
          <div class="close__popup_Design">
            <button
              class="btn btn-trans ml-3"
              (click)="isDispalyMenu = false; show_video = false"
            >
              <svg role="img" class="">
                <use xlink:href="#icon-expand"></use>
              </svg>
            </button>
          </div>
          <!--<h6 style="text-align: center;">Included Prompts</h6>-->
          <div class="video_container" *ngIf="show_video && isDispalyMenu">
            <video
              class="video_player"
              #videoPlayer
              controls
              width="100%"
            ></video>

            <div class="below_content">
              <div
                class="add_message"
                (click)="removeVideo()"
                [style.color]="is_video ? '#1db6bb' : ''"
              >
                <h6>
                  Remove Video
                  <span><i class="ml-1 fa-solid fa-video"></i></span>
                </h6>
              </div>
            </div>
          </div>

          <!-- Back button to return to main modal -->
          <div class="text-center mt-4 mb-2" *ngIf="!show_video">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="isDispalyMenu = false"
            >
              <i class="fas fa-arrow-left"></i>&nbsp; Back to Request
            </button>
          </div>
        </div>
        <ng-container
          *ngIf="
            showRequestedUser &&
            requestedMembers.length > 1 &&
            !showemailSection
          "
        >
          <div class="author_container mt-2 mb-3">
            <div class="author-label-toggle">
              <div class="author-toggle-text">
                <h6 class="font-weight-bold mb-0">Change Requestor</h6>
                <p class="author-toggle-subtext">
                  Send this request on behalf of someone else
                </p>
              </div>
              <label class="switch">
                <input
                  type="checkbox"
                  [(ngModel)]="showAuthorDropdown"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="onAuthorToggleChange($event)"
                />
                <span
                  class="slider"
                  [style.background-color]="
                    showAuthorDropdown && secondary_button_color
                      ? secondary_button_color
                      : ''
                  "
                ></span>
              </label>
            </div>
            <div class="job__select" *ngIf="showAuthorDropdown">
              <ng-select
                class="job-select"
                [placeholder]="''"
                [items]="requestedMembers"
                [multiple]="false"
                [closeOnSelect]="true"
                [selectableGroup]="true"
                maxSelectedItems="1"
                bindValue="id"
                bindLabel="title"
                formControlName="externalUserSelcted"
              >
                <ng-template
                  ng-option-tmp
                  let-item="item"
                  let-item$="item$"
                  let-index="index"
                >
                  <div class="mobile-check custom-control custom-checkbox">
                    <input
                      id="item-{{ index }}"
                      class="custom-control-input"
                      type="checkbox"
                      [ngModelOptions]="{ standalone: true }"
                      [ngModel]="item$.selected"
                    />
                    <label class="custom-control-label">{{ item.title }}</label>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </ng-container>

        <div
          class="row froala-wysiwyg"
          *ngIf="!showemailSection"
          [formGroup]="requestForm"
        >
          <div class="col-12 request_edit">
            <!--<h6>Personal Message</h6>-->
            <gs-area-wysiwyg
              label="Content"
              name="Message"
              placeholder="Add a popup greeting, instructions, or a story tip..."
              rows="7"
              cssClass="spacing-lg"
              is
              name="Content"
              formControlName="message"
              [formControl]="requestForm.controls.message"
              type="text"
              [autoFocus]="true"
            ></gs-area-wysiwyg>
          </div>
        </div>

        <div class="generate__box">
          <div class="mr-3">
            <button
              type="button"
              *ngIf="showemailSection"
              [style.background]="primary_color ? primary_color : ''"
              [disabled]="
                (requestForm.value.externalcampaign == -1 &&
                  requestForm.value.externalquestion == -1) ||
                isGreetingVideoPending ||
                !requestForm.controls.note_email.value ||
                disableSubmit
              "
              (click)="backGuestStories()"
              class="invite_guest btn min-width rs-footer-btn rs-footer-btn--secondary"
            >
              {{ "Back" }} &nbsp;
            </button>
          </div>
          <ng-container *ngIf="!showemailSection">
            <div>
              <button
                type="button"
                (click)="
                  isSingleInternalRequested
                    ? copyExternalUrl()
                    : GenearateExternalMainlLink()
                "
                [disabled]="
                  (requestForm.value.externalcampaign == -1 &&
                    requestForm.value.externalquestion == -1) ||
                  isGreetingVideoPending ||
                  !requestForm.controls.note_email.value ||
                  disableSubmit
                "
                [style.background]="primary_color ? primary_color : ''"
                class="invite_guest btn min-width rs-footer-btn rs-footer-btn--primary"
              >
                {{ isSingleInternalRequested ? buttonText : "Get Link" }} &nbsp;
                <span><i class="fas fa-link"></i></span>
              </button>
            </div>
          </ng-container>
          <ng-container *ngIf="!showemailSection">
            <div>
              <button
                type="button"
                (click)="shareadthis()"
                [disabled]="!isSingleInternalRequested || disableSubmit"
                [style.background]="primary_color ? primary_color : ''"
                class="invite_guest btn min-width rs-footer-btn rs-footer-btn--secondary"
              >
                Share &nbsp; <span><i class="fa-regular fa-share"></i></span>
              </button>
            </div>
          </ng-container>
          <ng-container>
            <div>
              <button
                type="button"
                (click)="sendExternalMainEmail()"
                [disabled]="
                  (!isSingleInternalRequested && !showemailSection) ||
                  (showemailSection && !lastUserValid) ||
                  disableSubmit
                "
                [style.background]="primary_color ? primary_color : ''"
                class="invite_guest btn min-width rs-footer-btn rs-footer-btn--secondary"
              >
                {{ !showemailSection ? "Email" : "Send" }} &nbsp;
                <span><i class="fa-regular fa-envelope"></i></span>
              </button>
            </div>
          </ng-container>

          <ng-container>
            <div class="lang-icon-select" *ngIf="!showemailSection">
              <button
                type="button"
                class="rs-footer-btn rs-footer-btn--secondary"
                (click)="toggleLangDropdown($event)"
              >
                <i class="far fa-language"></i>
                <span>Translate</span>
              </button>

              <!-- CUSTOM DROPDOWN -->
              <ul class="icon-dropdown" *ngIf="langDropdownOpen">
                <li
                  *ngFor="let lang of selectedLanguages"
                  (click)="selectLanguage(lang, $event)"
                  [class.active]="
                    lang.code === requestForm.get('languageSelected')?.value
                  "
                >
                  <img [src]="lang.flag" width="20" height="14" />
                  {{ lang.name }}
                </li>
              </ul>
            </div>
          </ng-container>
          <div
            class="remark-box__adthis"
            [@showhideadthis]="isDispalyadthis ? 'show' : 'hide'"
          >
            <div class="close__popup_Design">
              <button class="btn btn-trans ml-3" (click)="closeshare()">
                <svg role="img" class="">
                  <use xlink:href="#icon-collapse"></use>
                </svg>
              </button>
            </div>
            <div
              #shareholic
              class="shareaholic-canvas"
              data-app="share_buttons"
              data-app-id="33117316"
            ></div>
          </div>
        </div>
        <a
          *ngIf="externalUrlforCopy && isSingleInternalRequested"
          class="link_preview"
          [href]="externalUrlforCopy"
          target="_blank"
        >
          Click to Preview
        </a>
      </ng-container>
    </div>

    <div class="preview_body" *ngIf="isShowModal">
      <div class="preview-body">
        <ng-container *ngIf="isShowmedia">
          <app-storyflow-card-gallery-request
            [storyflowMenu]="menu"
            [menuActive]="stepActive"
            [interviewStyle]="false"
            [companyID]="companyId"
            [campaignId]="requestForm?.value?.campaign > 0 ? requestForm.value.campaign : initialState?.campaignId"
            [questionModels]="questionModels"
            [showPreviousNextButton]="false"
            [currentCompany]="company"
            [inbound_builder]="false"
            [videoduration]="30"
            [reduceHeight]="false"
          ></app-storyflow-card-gallery-request>
        </ng-container>

        <ng-container *ngIf="isshowTag">
          <app-storyflow-card-tags-request
            [reduceHeight]="false"
            aria-label="Tags"
            tabindex="2"
            [inboundBuilder]="false"
            [companyId]="companyId"
            [stepId]="2"
            [inbound]="false"
            (closetagBox)="closetagbox($event)"
          >
          </app-storyflow-card-tags-request>
        </ng-container>
      </div>

      <div class="menu">
        <storyflow-menu-request
          [showHomeButton]="'true'"
          [isMediaIncluded]="true"
          [mediaIndex]="0"
          [storyflowMenu]="menu"
          [menuActive]="stepActive"
          (openTagView)="openTag($event)"
        >
        </storyflow-menu-request>
      </div>

      <!-- Bottom Tab-Style Minimize Button -->
      <div
        class="story-builder-bottom-tab"
        role="button"
        tabindex="0"
        aria-label="Close tags and media"
        (click)="closeStoryBuilder()"
        (keydown.enter)="closeStoryBuilder()"
      >
        <svg role="img">
          <use xlink:href="#icon-collapse"></use>
        </svg>
      </div>
    </div>
  </div>

  <mux-uploader
    id="my-uploader-gs"
    class="mux-uploader-hidden"
    no-progress
    no-status
    no-drop
    no-retry
    dynamic-chunk-size
    hidden
  >
    <button
      class="btn"
      type="button"
      slot="file-select"
      aria-label="Select a file"
    >
      Pick a file
    </button>
  </mux-uploader>
</ng-container>
